<template>
  <v-text-field
    autocomplete="on"
    class="input-styles"
    type="password"
    :label="label"
    :rules="[lengthRule, passwordsMatchRule, requiredRule]"
    :value="confirmPassword"
    @input="(val) => update('confirmPassword', val)"
    height="48"
    placeholder=" "
    outlined
    persistent-placeholder
    required
  ></v-text-field>
</template>

<script>
export default {
  name: "ConfirmPasswordInput",
  methods: {
    lengthRule(value) {
      return (value && value.length > 5) || "Min 6 characters";
    },
    passwordsMatchRule(value) {
      return value === this.password || "Password must match";
    },
    requiredRule(value) {
      return !!value || "Required.";
    },
  },
  props: {
    confirmPassword: String,
    label: String,
    password: String,
    update: Function,
  },
};
</script>
